<template>
  <div id="Account" class="row">
    <div class="container-fluid">
      
      <div class="row csp-margin-top">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <p class="csp-account-id">Your Account</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <div class="card">
            <!--Card content-->
            <div class="card-block container-fluid">
                <!--Title-->
                <div class="row">
                  <h4 class="col-xs-12 card-title csp-card-title">{{ user.fullName }}</h4>
                </div>
                <!--Text-->
                <div class="row csp-margin-bottom" >
                  <div class="col-xs-12 ">
                    <span class="card-text csp-banner-text">{{ user.emailAddress }}</span><br />
                    <div v-if="user.phoneNumberHome"><span class="card-text csp-banner-text">{{ user.phoneNumberHome | phone}}</span><br /></div>
                    <div v-if="user.phoneNumberMobile"><span class="card-text csp-banner-text">{{ user.phoneNumberMobile | phone }}</span></div>
                   </div>                
                </div>
            </div>
            <!--/.Card content-->
          </div>
        </div>
      </div>
      <!--/.Card-->
      
      <div class="row csp-margin-top">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <p class="csp-account-id">Your Services</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ">
          <div class="card">
            <!--Card content-->
            <div class="card-block container-fluid">
                <!--Title-->
                <div class="row csp-margin-bottom">
                  <h4 class="col-xs-12 card-title csp-card-title">{{ address.line1 }}</h4>
                  <span class="col-xs-12 card-title csp-card-title">{{ address.line2 }}</span>
                  <span class="col-xs-12 card-title csp-card-title" :class="{ hidden: !ready }">{{ address.city }}, {{ address.state }} {{ address.zip }}</span>
                </div>
                <!--Text-->
                <div class="row csp-margin-bottom" >
                  <div class="col-xs-11 col-xs-offset-1 ">
                    <hr class="csp-account-margin">
                    <span class="card-text csp-banner-text">{{ service.serviceYear }} Service Choices:</span><br />
                    <div v-if="service.springCleanup"><span class="card-text csp-banner-text">Step 1 - Spring Cleanup</span><br /></div>
                    <div v-if="service.summerMaintenance"><span class="card-text csp-banner-text">Step 2 - Summer Maintenance</span><br /></div>
                    <div v-if="service.fallCleanup"><span class="card-text csp-banner-text">Step 3 - Fall Cleanup</span><br /></div>
                    <div v-if="service.selected.length === 0"><span class="card-text csp-banner-text csp-data-missing">(No Services Selected)</span></div>
                    <hr class="csp-account-margin">
                   </div>                
                </div>
            </div>
            <!--/.Card content-->
          </div>
        </div>
      </div>
      <!--/.Card-->
      
      <div class="row csp-margin-top">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 csp-text-center">
          <p class="csp-title-text">If you have any questions or need to change any information, please 
          <router-link to="/SendMessage" class="csp-router-link-text" >send us a message</router-link>.</p>
        </div>
      </div>
      
      <trailer></trailer>
      
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import Trailer from '../components/Trailer'
  
  Vue.filter('phone', function (phone) {
    return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  })
  
  export default {
    name: 'Account',
    components: {
      Trailer
    },
    computed: {
      ...mapGetters([
        'user',
        'address',
        'service',
        'company',
        'companyPhoneNumber',
        'copyrightYear',
        'website'
      ]),
      ready: function () {
        return this.address.city !== ''
      }
    }
  }
</script>

<style scoped>

  .csp-card-success{
      padding: 20px 0px 5px 0px;
      background-color: rgba(107, 143, 83, 1);
      font-weight:bold;
  }
  
  .csp-router-link-text {
    color: white;
    border-bottom: 2px solid white;
    cursor: pointer;
    text-shadow: 0px 0px 4px #000;
    white-space: nowrap;
  }
  
  .csp-router-link-text:hover{
    border-bottom: 2px solid #6B8F53;
  }
  
  .csp-title-text{
    font-size: 14px;
    padding:0px;
  }
  
  .csp-margin-bottom{
    margin-bottom: 2vh;
  }
  
  .csp-margin-top{
    margin-top: 4vh;
  }
  
  hr.csp-account-margin{
    margin:0px;
  }
  
  .csp-account-id{
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 1.15;
    color: #FCFCFC;
    opacity: 1.00;
    text-shadow: 0px 0px 4px #000;
    
  }
  
  .csp-data-missing{
    font-style: italic;
  }
  
  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// Account.vue?b7747606